/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingLinkResponseModel } from '../../models/onboarding-link-response-model';

export interface AnonymousBranchOnboardingLinkLongitudeLatitudeGet$Params {
  longitude: number;
  latitude: number;
}

export function anonymousBranchOnboardingLinkLongitudeLatitudeGet(http: HttpClient, rootUrl: string, params: AnonymousBranchOnboardingLinkLongitudeLatitudeGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OnboardingLinkResponseModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousBranchOnboardingLinkLongitudeLatitudeGet.PATH, 'get');
  if (params) {
    rb.path('longitude', params.longitude, {});
    rb.path('latitude', params.latitude, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OnboardingLinkResponseModel>;
    })
  );
}

anonymousBranchOnboardingLinkLongitudeLatitudeGet.PATH = '/Anonymous/BranchOnboardingLink/{longitude}/{latitude}';
